import { Stack } from "@fluentui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { HoverButton } from "../components/hoverButton";
import '../App.css'

//TODO: Add something to the screen that lets the user know what this site is - As a user they may not know what this is all about - maybe something like, need access to Nexon resources? Click on the buttons to register or sign up
export const Home: React.FunctionComponent = () => {
    const navigate = useNavigate();
    return (
    <>
    <Stack className="flex-container-col full-height">
        <Stack className="flex-items-col border">
        </Stack>
        <Stack className="flex-items-col border black-background full-height">
            <Stack className="center full-height">
                <a href ={'https://riverlee.com.au/'}>
                    <img src={require("../riverleeLogo.png")} width="35%" alt="Riverlee logo" />
                </a>
                <br></br>
                <br></br>
                <br></br>
                {HoverButton('Existing Users',()=>{navigate('existing_users')})}
                {/* <br></br> */}
                {HoverButton('New Users',()=>{navigate('new_users')})}
            </Stack>
        </Stack>
    </Stack>
    </>
    );
}